export default __webpack_public_path__ + "static/media/hands.a3e010c3.png";